import {
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import styled from "styled-components";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

const roboto = (props) => props.theme.fonts.roboto;
const primary = (props) => props.theme.palette.primary;
const grey = (props) => props.theme.palette.grey;
const orange = (props) => props.theme.palette.orange;

export const ParamsHeader = styled.div`
  margin-bottom: 30px;
`;

export const ParamsContent = styled.div``;

export const SwitchesFormControlLabel = styled(FormControlLabel)`
  .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
    font-weight: 600 !important;
  }
`;

export const GridSpacedItems = styled(Grid)`
  .MuiGrid-root.MuiGrid-item:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const Subtitle = styled.span`
  font-family: ${roboto};
  display: block;
  color: ${grey};
`;

export const CustomDialogContent = styled(DialogContent)`
  min-height: 57vh;

  ::-webkit-scrollbar {
    background-color: ${primary};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${orange};
  }
`;

export const CustomButton = styled(Btn)`
  height: 45px;
  padding: 10px 20px !important;

  .MuiButton-label {
    font-size: 1rem;
    font-weight: bold;
  }
`;

export const HelperText = styled.div`
  padding: 8px;
  font-weight: bold;
  font-family: ${roboto};
  text-align: right;
`;

export const IconButtonCustom = styled(IconButton)`
  color: white !important;
  margin-left: 12px !important;
  border: 2px solid !important;
`;

export const ImageContainer = styled.div`
  display: flex;
  width: 200px;
  margin-right: 12px;

  img {
    width: 100%;
  }
`;

export const StyledChip = styled(Chip)`
  height: auto !important;
  width: 100%;
  border-radius: 10px !important;
  margin: 0;
  justify-content: flex-start !important;

  .MuiChip-label {
    padding-left: 16px !important;
    font-size: 1.3rem;
    font-weight: bold;
    color: white;
    padding: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const HelperSubtitle = styled(Typography)`
  font-weight: bold !important;
  margin-bottom: 12px !important;
`;
